module.exports = __webpack_public_path__ + "img/banner.1af21cc5.png";